import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import {
  UpdateInventoryAmount,
  UpdateInventoryAmountParams,
} from "../../domain/usecases/update-inventory-amount";
import { InvalidFieldError } from "../../validation/errors";
import { HttpClient } from "../protocols/http";

export class DbUpdateInventoryAmount implements UpdateInventoryAmount {
  constructor(
    private readonly url: string,
    private readonly httClient: HttpClient
  ) {}
  async update(params: UpdateInventoryAmountParams): Promise<void> {
    const res = await this.httClient.request({
      url: this.url,
      method: "post",
      body: params,
    });

    if (res.statusCode > 199 && res.statusCode < 300) {
      return res.body;
    } else {
      if (res.statusCode === 401 || res.statusCode === 403) {
        throw new UnauthorizedError();
      }
      if (res.statusCode === 400) {
        throw new InvalidFieldError();
      }
      throw new Error(
        res.body.error.message ||
          res.body.error.data.message ||
          "Ocorreu um erro. Tente novamente em breve"
      );
    }
  }
}
